<app-header-four [themeLogo]="themeLogo"></app-header-four>
<router-outlet></router-outlet>
<app-footer-four
  [class]="'footer-light pet-layout-footer'"
  [themeLogo]="themeLogo"
></app-footer-four>
